import React, { useEffect, useRef, useState } from "react";
import {
  Box,
  CssBaseline,
  Toolbar,
  useTheme,
  useMediaQuery,
} from "@mui/material";
import { Outlet, useLocation, useNavigate } from "react-router-dom";

import { useAuth, useCurrentTalentProfile } from "../hooks";
import { useGetBookings } from "../services/api/booking.api";
import Footer from "../components/Footer/Footer";

import BusinessSidebar from "./BusinessSidebar";
import HeaderBusiness from "./HeaderBusiness";
import useCurrentBusinessInfo from "../hooks/useCurrentBusiness";
import SocketHandler from "../utils/socketHandler";
import { getUserSocketNotification } from "../utils/notificationHandler";
import UserSidebar from "./UserSidebar_upated";
import Header from "./Header_new";

const BusinessLayout: React.FC = () => {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("sm"));
  const [drawerOpen, setDrawerOpen] = useState(!isMobile);
  const { currentBusiness } = useCurrentBusinessInfo();
  const socketSubscribedRef = useRef(false);
  const { userInfo } = useAuth();
  const { data, isLoading, error } = useGetBookings({
    key: ["bookings", userInfo?.id],
  });

  const { currentProfile } = useCurrentTalentProfile();

  const toggleDrawer = () => setDrawerOpen((prev) => !prev);
  const location = useLocation();
  const navigate = useNavigate();
  const [badgeVisible, setBadgeVisible] = useState(false);

  const [socketNotification, setSocketNotification] = useState<any>([]);
  const [coffeeJoinChannel, setCoffeeJoinChannel] = useState<string | null>(
    null
  );

  const handleClose = () => {
    setDrawerOpen(false);
  };

  const CreateCard = () => navigate("/create-card");

  useEffect(() => {
    // Prevent multiple subscriptions
    if (socketSubscribedRef.current || !userInfo?.id) {
      return;
    }

    try {
      // Get socket instance and subscribe to messages
      const socketHandler = SocketHandler.getInstance();

      socketHandler.subscribeToNotification(
        userInfo.id.toString(),
        (message) => {
          if (message) {
            console.log("messages are here in main layout", message);

            console.log(
              "currentBusiness?.id are here in main layout",
              currentBusiness?.id
            );
            const notification = getUserSocketNotification(message);
            if (notification) {
              setSocketNotification((prev: any) => [...prev, notification]);
              setBadgeVisible(true);
            }
          }
        }
      );

      socketSubscribedRef.current = true;
      console.log("Successfully subscribed to notification socket");
    } catch (error) {
      console.error("Failed to subscribe to socket:", error);
    }

    // Cleanup subscription when component unmounts
    return () => {
      try {
        if (userInfo?.id) {
          const socketHandler = SocketHandler.getInstance();
          socketHandler.unsubscribeFromNotification(userInfo.id.toString());
          socketSubscribedRef.current = false;
          console.log("Successfully unsubscribed from notification socket");
        }
      } catch (error) {
        console.error("Failed to unsubscribe from socket:", error);
      }
    };
  }, [userInfo?.id, currentBusiness?.id]);

  return (
    <Box sx={{ display: "flex" }}>
      <CssBaseline />

      <Header
        toggleDrawer={toggleDrawer}
        onClickCreate={CreateCard}
        setBadgeVisible={setBadgeVisible}
        badgeVisible={badgeVisible}
        socketNotification={socketNotification}
      />

      {currentBusiness ? (
        <BusinessSidebar handleClose={handleClose} open={drawerOpen} />
      ) : (
        <UserSidebar open={drawerOpen} handleClose={handleClose} />
      )}

      <Box
        component="main"
        sx={{
          flexGrow: 1,
          display: "flex",
          flexDirection: "column",
          minHeight: "100vh",
          px: { xs: 1, md: 3 },
          py: 3,
          overflow: "hidden",
        }}
      >
        <Toolbar />

        <Box sx={{ flexGrow: 1 }}>
          <Outlet />
        </Box>
        <Footer />
      </Box>
    </Box>
  );
};

export default BusinessLayout;
